module.exports = __webpack_public_path__ + "img/bc.f5fa17ac.png";